/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerGoogleBigQuerySourceComponent', [
    '$rootScope',
    'DesignerDatabaseBaseSourceComponent',

    function ($rootScope, DesignerDatabaseBaseSourceComponent) {
      function DesignerGoogleBigQuerySourceComponent() {
        DesignerDatabaseBaseSourceComponent.apply(this);

        this.use_legacy_sql = null;
        this.stored_procedure = null;
      }

      DesignerGoogleBigQuerySourceComponent.prototype = new DesignerDatabaseBaseSourceComponent();

      DesignerGoogleBigQuerySourceComponent.prototype.getData = function () {
        const data = DesignerDatabaseBaseSourceComponent.prototype.getData.call(this);

        _.extend(data, {
          use_legacy_sql: angular.isDefined(this.use_legacy_sql) ? this.use_legacy_sql : this.defaults.use_legacy_sql,
          stored_procedure: angular.isDefined(this.stored_procedure)
            ? this.stored_procedure
            : this.defaults.stored_procedure,
        });

        return data;
      };

      DesignerGoogleBigQuerySourceComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerDatabaseBaseSourceComponent.prototype.setFormData.call(this, data);
      };

      DesignerGoogleBigQuerySourceComponent.prototype.setData = function (data) {
        this.use_legacy_sql = data.use_legacy_sql;
        this.stored_procedure = data.stored_procedure;

        DesignerDatabaseBaseSourceComponent.prototype.setData.call(this, data);
      };

      return DesignerGoogleBigQuerySourceComponent;
    },
  ]);
})(window.angular);
